import { Injectable, ViewChild } from '@angular/core';
// import { Events, Content } from "@ionic/angular";
import { Song } from '../data/Song';
import { FirestoreService } from './FirestoreService';
import { AudioService } from './AudioService';
import { AuthService } from './AuthService';
import { ModelService } from './modalService';
import { BehaviorSubject, Observable } from 'rxjs';
// import { interval } from 'rxjs';
// import { takeUntil } from "rxjs";
import { Subject } from 'rxjs';
// import { take } from "rxjsoperator/take";
// import { timer } from "rxjsobservable/timer";
// import { takeWhile } from "rxjsoperator/takeWhile";
import { of } from 'rxjs';
// import { scan } from "rxjsoperators";
// import { switchMap } from "rxjsoperator/switchMap";
// import { startWith } from "rxjsoperator/startWith";
// import { empty } from "rxjsObserver";

declare var $: any;

@Injectable()
export class SongPlayingService {
  // noSongPlaying: Subject<boolean> = new BehaviorSubject(true);
  pause: any;
  playingSong: Subject<any> = new BehaviorSubject(null);
  duration: Subject<any> = new BehaviorSubject(0);
  interval: any;
  interval$: Observable<any>;
  position: number = 0;
  position$: Subject<number> = new BehaviorSubject(0);
  isLikeLoaded: boolean;
  shuffle: boolean;
  intervalClear: boolean = true;
  stopPlay$: Subject<any> = new Subject();
  duration$: Subject<any> = new BehaviorSubject(0);
  // pause$: Subject<any> = new Subject();
  resume$: Subject<any> = new Subject();
  stop: any;
  // pause$: Subject<boolean> = new BehaviorSubject(true);// this.audioService.pause$["value"];
  songPlayed: boolean = false;
  counterSubject: Subject<{ pause?: boolean; counterValue?: number }> =
    new Subject();
  constructor(
    private modelService: ModelService,
    private audioService: AudioService,
    private firestoreService: FirestoreService
  ) {
    // this.getDuration();

  }
  getSong() {
    var playingTrack = this.audioService.playingTrack();
    // this.duration.next(0);
    // console.log("playing track ", playingTrack);
    if (playingTrack) {
      // this.pause = this.modelService.pause;
      // this.noSongPlaying.next(false);
      this.songPlayed = true;

      clearInterval(this.interval);
      this.intervalClear = true;

      this.position = 0;
      this.firestoreService
        .getSong(playingTrack.songId)
        .then(
          (result: any) => {
            console.log({playingTrack});
            this.playingSong.next(result.song);
            setTimeout(() => {
              this.duration.next(playingTrack.duration);
              // setTimeout(() => {
                if(playingTrack.isPlaying){
                  // this.getPosition();
                }
              // });
    
              console.log(
                'playing track duration', playingTrack.duration,
                // this.noSongPlaying['value']
              )
            }, 100);


            // this.pause$ = this.audioService.pause$;
            // this.pause = this.modelService.pause;
            // this.songFinished.next(this.pause);
            // this.songFinished.next(false);

            // this.getPosition();
            // console.log('duration subsribe', this.duration["value"]);
            // console.log('duration', this.duration["value"]);
            // this.intervalClear = false;
          },
          (e) => console.log('no song is played', e)
        )
        .catch((e) => console.log('no song is played', e));
    } else {
      // this.noSongPlaying.next(true);
    }
  }

  getDuration() {
    console.log('gettting duration', this.duration['value'])
    if (this.duration['value'] == 0 || this.duration['value'] == undefined) {
      this.audioService.song$.subscribe((modelSongs: any) => {
        setTimeout(() => {
          this.playingSong.next(modelSongs[0])
          this.duration.next(modelSongs[0].duration) //= modelSongs[0].duration;
        }, 200);

        // }
      })
    }
  }


  getShuffleStatus() {
    this.shuffle = !this.shuffle;
    console.log("Shuffle status", this.shuffle);
  }

  getPosition() {
    // this.position = 0;i9
    //  clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.position++;

      if (this.position > this.duration['value']) {
        this.position = 0;
        this.pause = true;
        if (this.shuffle) {
          this.audioService.play();
          setTimeout(() => {
            this.getPosition();
          }, 1000);
        }
        else {
            this.audioService.stop();
        }
        // this.pause$.next(true);
        // this.songFinished.next(this.pause);
        this.intervalClear = true;
        clearInterval(this.interval);
      }
      // console.log('pause value', this.position);
      // console.log('position', this.position);

      this.position$.next(this.position);
      // })
    }, 1000);
  }

  playPause() {

    if (this.audioService.pause$['value']) {
      console.log('audio service pause value', this.audioService.pause$['value']);
      this.intervalClear = true;
      clearInterval(this.interval);  

    } else {
   
      this.intervalClear = false;
      this.getPosition();
    }

  }
  next() {
    this.audioService.next();

    this.isLikeLoaded = false;

    clearInterval(this.interval);
    this.intervalClear = true;

    this.position = 0;
    setTimeout(() => {
    this.getSong();
    // this.getPosition();
    }, 1000);
  }

  seekTo(pos) {
    // console.log({ pos });
    this.position = pos;
    this.audioService.seekTo(pos);
  }

  previous() {

    clearInterval(this.interval);
    this.intervalClear = true;

    this.position = 0;
    this.audioService.previous();

    // setTimeout(() => {
    this.getSong();
    this.getPosition();
    // }, 700);
  }
}
